import React from "react";
import "./about.scss";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";

// images
// import aboutImg from "../../../assets/images/me/about-img.jpeg";
import aboutImg from "../../../assets/images/me/nur-alam.jpg";
import AboutCard from "../../cards/aboutCard/AboutCard";
import contryImg from "../../../assets/images/about/con1.jpg";
// import contryImg from "../../../assets/images/about/cal1.png";

// data
import aboutCardData from "../../../assets/data/aboutCardData";
import LayoutAnimations from "../../animations/LayoutAnimations";

const About = () => {
  return (
    <section id="about">
      <Wrapper>
        <div className="about">
          <LayoutAnimations propVarient={"leftToRight"}>
            <div className="about__left">
              <CommonHeader
                title="About"
                subtitle="introduction"
                bgText="About Me"
              />

              <div className="about__content">
                <span className="aboutContent__headText">
                  <span>E-commerce Expert</span>
                </span>

                <span className="aboutContent__desc">
                  Hi, Thanks for visiting my website. It's me Nur Alam a Shopify
                  Expert and E-commerce Developer. I am also a shopify products
                  entry specialist.
                  <br />
                  <br />
                  I am also a professional experienced, lead full-stack
                  developer. I build top-quality, user-friendly, and responsive
                  custom websites.
                  <br />
                  <br />
                  I have much experience with creating one product shopify
                  website, uploading products, bulk import, converting any
                  vendor or supplier file, shopify shipping and tax setup,
                  shopify speed optimization, importing shopify product reviews,
                  shopify customization, creating shopify csv, writing product
                  descriptions and navigation, menu or mega-menu setup, etc.
                  <br />
                  <br />I am dedicated to empowering businesses to thrive in the
                  digital landscape. Let us be your partner in success on the
                  Shopify platform. Get in touch today to discuss how I can
                  elevate your e-commerce journey!
                  {/* Hi, Thanks for visiting my website. It's me Nur Alam a Shopify
                  E-commerce Specialist. I am a professional experienced,
                  professional lead full-stack Developer. I build top-quality,
                  user-friendly and responsive custom websites. I have must
                  experience with Shopify CSV, product listing, bulk import,
                  upload products, shipping setup, speed optimization, import
                  reviews and many more for Shopify Stores. Actually, I can
                  set-up any setting for the Shopify Website. */}
                </span>

                <div className="about__cards">
                  {aboutCardData.map((item, index) => (
                    <AboutCard
                      key={index}
                      icon={item.icon}
                      title={item.title}
                      desc={item.desc}
                    />
                  ))}
                </div>
              </div>
            </div>
          </LayoutAnimations>

          <LayoutAnimations propVarient={"rightToLeft"}>
            <div className="about__right">
              <img src={aboutImg} alt="" />
            </div>
          </LayoutAnimations>
        </div>

        <div>
          <div className="work_countries">
            <div className="wc_tBox">
              <span>
                Providing Shopify Development and Management Services
                in 50+ Countries.
              </span>
            </div>

            <img src={contryImg} alt="" />
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default About;
